var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"placeholder":_vm.$t('common.selects.country'),"track-by":"country","label":"country","id":"country_id","options":_vm.countries},model:{value:(_vm.selectedCountry),callback:function ($$v) {_vm.selectedCountry=$$v},expression:"selectedCountry"}})
}
var staticRenderFns = []

export { render, staticRenderFns }